if (!customElements.get('rs-mega-menu')) {
  customElements.define('rs-mega-menu', class extends HTMLElement {
    connectedCallback() {
      this._imageArea    = this.querySelector('[data-mega-images]');
      this._l1Handle     = this.dataset.l1 || '';
      this._baseLinkCols = parseInt(this.dataset.linkCols) || 3;

      this.querySelectorAll('[data-mega-l3]').forEach(trigger => {
        trigger.addEventListener('mouseenter', () => this._activateL3(trigger));
      });

      // Debounced clear — skip links inside no-trigger columns (e.g. Shop BaubleBar).
      // A plain L3 link with an attached image (e.g. NFL) swaps that image in even though it opens no panel; one with no image falls back to hiding all.
      this.querySelectorAll('.rs-megamenu__l3link:not([data-mega-l3])').forEach(link => {
        if (link.closest('.rs-megamenu__col--no-triggers')) return;
        const imageHandle = link.dataset.megaImage || '';
        link.addEventListener('mouseenter', () => {
          clearTimeout(this._clearTimer);
          this._clearTimer = setTimeout(() => this._clearPanel(imageHandle), 200);
        });
      });

      this.querySelectorAll('[data-mega-l4]').forEach(trigger => {
        trigger.addEventListener('mouseenter', () => this._activateL4(trigger));
      });

      this.querySelectorAll('.rs-megamenu__l4link:not([data-mega-l4])').forEach(link => {
        link.addEventListener('mouseenter', () => {
          clearTimeout(this._l5ClearTimer);
          this._l5ClearTimer = setTimeout(() => this._resetL5(), 200);
        });
      });

      this.addEventListener('mouseleave', () => this._reset());
      this._restoreDefault();
    }

    _activateL3(trigger) {
      clearTimeout(this._clearTimer);
      const handle = trigger.dataset.megaL3;
      this.querySelectorAll('[data-mega-l3]').forEach(t => t.classList.remove('is-active'));
      trigger.classList.add('is-active');
      this._showPanel(handle);
      this._resetL5();
      this._swapImage(handle);
    }

    _clearPanel(imageHandle) {
      this.querySelectorAll('[data-mega-l3]').forEach(t => t.classList.remove('is-active'));
      this.querySelectorAll('[data-mega-panel]').forEach(p => { p.hidden = true; });
      this.classList.remove('rs-megamenu--panel-active');
      this.style.removeProperty('--mega-link-cols');
      this._resetL5();
      this._swapImage(imageHandle || '');
    }

    _showPanel(handle) {
      this.querySelectorAll('[data-mega-panel]').forEach(p => { p.hidden = true; });
      const panel = this.querySelector(`[data-mega-panel="${handle}"]`);
      if (panel) {
        panel.hidden = false;
        this.classList.add('rs-megamenu--panel-active');
        this.style.setProperty('--mega-link-cols', this._baseLinkCols + 1);
      } else {
        this.classList.remove('rs-megamenu--panel-active');
        this.style.removeProperty('--mega-link-cols');
      }
    }

    _activateL4(trigger) {
      clearTimeout(this._l5ClearTimer);
      const handle = trigger.dataset.megaL4;
      const l5Slot = this.querySelector('[data-mega-l5slot]');
      if (!l5Slot) return;

      this.querySelectorAll('[data-mega-l4]').forEach(t => t.classList.remove('is-active'));
      trigger.classList.add('is-active');

      l5Slot.querySelectorAll('[data-mega-l4panel]').forEach(p => { p.hidden = true; });
      const l5Panel = l5Slot.querySelector(`[data-mega-l4panel="${handle}"]`);
      if (l5Panel) {
        l5Panel.hidden = false;
        this.style.setProperty('--mega-link-cols', this._baseLinkCols + 2);
        if (this._baseLinkCols >= 2) this.classList.add('rs-megamenu--l5-open');
      }
    }

    _resetL5() {
      const l5Slot = this.querySelector('[data-mega-l5slot]');
      if (l5Slot) l5Slot.querySelectorAll('[data-mega-l4panel]').forEach(p => { p.hidden = true; });
      this.querySelectorAll('[data-mega-l4]').forEach(t => t.classList.remove('is-active'));
      if (this.classList.contains('rs-megamenu--panel-active')) {
        this.style.setProperty('--mega-link-cols', this._baseLinkCols + 1);
      } else {
        this.style.removeProperty('--mega-link-cols');
      }
      this.classList.remove('rs-megamenu--l5-open');
    }

    _swapImage(handle) {
      if (!this._imageArea) return;
      let found = false;
      this._imageArea.querySelectorAll('[data-image-for]').forEach(p => {
        const match = p.dataset.imageFor === handle;
        p.classList.toggle('is-active', match);
        if (match) found = true;
      });
      // Fall back to default only on L1 restore; empty handle hides all images
      if (!found && handle === this._l1Handle) {
        const def = this._imageArea.querySelector('[data-image-default]');
        if (def) def.classList.add('is-active');
      }
    }

    _restoreDefault() {
      clearTimeout(this._clearTimer);
      this.querySelectorAll('[data-mega-l3]').forEach(t => t.classList.remove('is-active'));
      this.querySelectorAll('[data-mega-panel]').forEach(p => { p.hidden = true; });
      this.classList.remove('rs-megamenu--panel-active');
      this.style.removeProperty('--mega-link-cols');
      this._resetL5();
      this._swapImage(this._l1Handle);
    }

    _reset() {
      this._restoreDefault();
    }
  });
}
